import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { debounceTime, switchMap } from "rxjs/operators";
import { TypeActionTutorial } from "../../../tutorial/actionTutorial";
import { actionGameTrackingUpdateClientFunnel } from "../../actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../IdGameTrackingClientFunnelState";
export var epicGameTrackingClientFunnelTutorial = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTutorial.Select), debounceTime(10), switchMap(function (action) {
        if (action.tutorialStep && IdGameTrackingClientFunnelState[action.tutorialStep]) {
            var tutorialStep = IdGameTrackingClientFunnelState[action.tutorialStep];
            return of(actionGameTrackingUpdateClientFunnel(tutorialStep));
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epics/epicGameTrackingClientFunnelTutorial.ts
// module id = 1873
// module chunks = 3